































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig, UseModal } from "@/components/root/modal";
import * as api from "../data/api";
import Spinner from "@/components/Spinner.vue";
import { onBeforeUnmount, onMounted } from "@vue/composition-api";
import { MassDownloadUser } from "../data/model";
import MassDownloaderRow from "./MassDownloaderRow.vue";
import { UseCollection } from "@/common/composition/use-collection";
import { SharedState } from "@/common/state";
import { table_config } from "./table.config";
import VirtualTable from "@/components/table/VirtualTable.vue";
import { emptyFn } from "@/fp";
import { EventBus } from "@/eventbus";
import { POPULATION_TYPE } from "@/common/models";
import MassDownloadPolicyScriptModalVue from "../MassDownloadPolicyScriptModal.vue";
export default Vue.extend({
  components: {
    Modal,
    Spinner,
    VirtualTable,
  },
  props: ["modalData"],
  setup(props) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "100rem",
      height: "52rem",
    };

    const users = UseCollection<
      MassDownloadUser,
      { cursor: string; l0_id: string }
    >(async ({ cursor, l0_id }) => {
      const res = await api.get_mass_download_users_for_l0({
        l0_id,
        cursor,
        date: SharedState.selectedTimeFrameOption.value.from,
        time_type: SharedState.selectedTimeFrameOption.value.type,
      });
      return res;
    });

    const subs = {
      inv: emptyFn(),
    };

    const investigate_user = async (item: MassDownloadUser) => {
      SharedState.investigation.investigate({
        name: item.name,
        id: item.id,
        type: POPULATION_TYPE.EMPLOYEE,
      });
    };

    const show_playbook = (label_id: string, label_name: string) => {
      if (SharedState.is_biz_user.value) {
        SharedState.restrictions.show_restrictions_modal("role", "Playbooks");
        return;
      }
      UseModal().show(MassDownloadPolicyScriptModalVue, {
        label_id,
        label_name,
      });
    };

    onMounted(async () => {
      // @ts-ignore
      const l0_id = props.modalData.id;
      await users.load_items({ cursor: "", l0_id });
      subs.inv = EventBus.listen("investigate", investigate_user);
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      config,
      MassDownloaderRow,
      table_config,
      is_loading: users.is_loading,
      has_no_results: users.has_no_results,
      users: users.items,
      load_more_users: users.load_more_items,
      show_playbook,
    };
  },
});
